export default __webpack_public_path__ + "static/SRUS 858 - Product Specifications & Technical Data-3b2f3c02e8f2302e1e4d8afefb932b7e.pdf";